'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGES_LOCK = exports.MESSAGES_LOCK = 'messages-lock';
var MESSAGES_CHAT = exports.MESSAGES_CHAT = 'messages-chat';
var MESSAGES_WRITE = exports.MESSAGES_WRITE = 'messages-write';
var MESSAGES_READ = exports.MESSAGES_READ = 'messages-read';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/Scopes.js
// module id = 153
// module chunks = 0 1